var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_536_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9026 24.5754C31.4891 14.9077 43.2501 4.13026 43.5906 3.78939C44.1208 3.24892 44.6889 2.7471 45.2906 2.28776C49.7576 -1.00805 55.9213 -0.715488 60.0571 2.98852C64.1926 6.69303 65.1658 12.7931 62.3886 17.6026C61.886 18.4853 61.2634 19.2939 60.5386 20.0052C58.1891 22.3572 49.1901 31.9166 49.1901 31.9166C49.1901 31.9166 60.9886 43.2774 61.1886 43.4275C64.1126 45.7723 64.8596 49.9173 62.9386 53.137C62.3696 54.0766 61.607 54.8839 60.7019 55.5052C59.7967 56.1266 58.7696 56.5477 57.6891 56.7404C57.0396 56.8553 48.4603 48.5891 38.9861 41.9009C32.9966 48.6277 21.0806 62.0056 21.0433 62.0056C15.9838 65.549 9.7946 63.5974 6.99485 62.0557C5.07939 60.9361 3.45459 59.3803 2.25233 57.5143C1.05008 55.6484 0.30423 53.5249 0.0753308 51.3163C-0.153568 49.1078 0.140929 46.8763 0.934921 44.803C1.72891 42.7297 3.00003 40.873 4.6451 39.3837C6.2951 37.8823 13.2941 31.5261 20.8933 24.5694L20.9026 24.5754Z",
    fill: "#0CB0F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9504 28.0273C41.6081 25.6806 40.364 23.5604 38.4831 22.1184L20.0549 3.44998C18.9106 2.30314 17.5418 1.40556 16.0344 0.813638C14.527 0.221711 12.9136 -0.0517784 11.2956 0.0103479C9.67758 0.0724741 8.08987 0.468874 6.63221 1.17465C5.17454 1.88042 3.87841 2.88032 2.82522 4.11154C1.77204 5.34276 0.98455 6.7787 0.512227 8.32917C0.0399033 9.87963 -0.107051 11.5111 0.0805935 13.1212C0.268238 14.7312 0.786428 16.285 1.60261 17.685C2.4188 19.0849 3.51535 20.3008 4.82338 21.2563L27.0694 36.8053C28.5389 37.9496 30.3179 38.6255 32.1758 38.7453C34.0336 38.8651 35.8846 38.4232 37.4885 37.4771C39.0925 36.531 40.3755 35.1242 41.1711 33.4393C41.9667 31.7543 42.2382 29.8686 41.9504 28.0273Z",
    fill: "url(#paint0_linear_536_22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9639 12.2039H51.8094V52.0925H11.9639V12.2039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.998 44.0152H30.5915V46.6581H15.998V44.0152ZM21.3273 28.0099L14.6035 17.4395H19.086L23.27 24.4698L27.5038 17.4397H31.8768L25.1528 27.9601V34.9406H21.3175V28.0099H21.3273ZM37.7638 20.9798H32.4343V17.4392H46.8783V20.9793H41.5988V34.8906H37.7638V20.9798Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_22",
    x1: 27.6758,
    y1: 25.8504,
    x2: 2.98511,
    y2: 0.143813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#905CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A554E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D641B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F43597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF318C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_536_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTrack);
export default __webpack_public_path__ + "static/media/YouTrack.0eb504e5d492645437e44722aec6dd4a.svg";
export { ForwardRef as ReactComponent };